import { Component, Input, OnInit } from '@angular/core';
import { AuthStoreService } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { TruScaleSidebarData } from 'src/app/core/model/promotion/truscale-sidebar-data';

@UntilDestroy()
@Component({
  selector: 'app-truscale-summary-widget',
  templateUrl: './truscale-summary-widget.component.html',
  styleUrls: ['./truscale-summary-widget.component.scss'],
})
export class TruscaleSummaryWidgetComponent implements OnInit {
  @Input() truScaleSidebarData: TruScaleSidebarData;
  isWallet = false;

  constructor(private authStore: AuthStoreService) {}

  ngOnInit(): void {
    this.authStore.isRegularUser$.pipe(untilDestroyed(this), filter(Boolean)).subscribe(() => {
      const companyDetails = (this.authStore.userSettings?.user as any)?.companies[0]?.leapCompanyDetails;
      if (companyDetails) {
        this.isWallet = companyDetails.isWallet;
      }
    });
  }
}
